const Menu = ({menu}) => {

	const parsedMenu = JSON.parse(menu);

	const topMenu = parsedMenu[Object.keys(parsedMenu)]; // get the object containing the info of the top-level menu

	const parseMenu = (menu) => {

		if (! menu) return null;

		if (! menu.children) return null;

		return Object.values(menu.children).map((child) => {
			return (
				<li className="sidebar__item list__item" key={child.title}>
					<a className="link" href={child.url} dangerouslySetInnerHTML={{__html: child.title}} />
					{/* recursive function to check if each child has children */}
					{Object.keys(child.children).length > 0 && (
						<ul className='sidebar__list nested'>
							{parseMenu(child)}
						</ul>
					)}
				</li>
			)
		})
	}


	return (
		<div className="sidebar">
			<div className="sidebar__title">
				<a href={topMenu.url} dangerouslySetInnerHTML={{__html: topMenu.title}} />
			</div>
			<div className="sidebar__body">
				<ul className='sidebar__list'>
					{topMenu.children && parseMenu(topMenu)}
				</ul>
			</div>
		</div>
	);
}

export default Menu;
